import { TEST_IDS } from "constants/TestIds";

import { Tree } from "../../Tree";
import { CountryLabel } from "./CountryLabel";
import { useCountryItem } from "./useCountryItem";

import type { SelectedCountry } from "../types";

export interface CountryItemProps {
  country: SelectedCountry;
}

export function CountryItem({ country }: CountryItemProps) {
  const { id, label } = country;
  const { isCountrySelected, handleToggleCountry } = useCountryItem();

  return (
    <Tree.Item
      data-testid={TEST_IDS.getCountry(id)}
      label={
        <CountryLabel
          id={id}
          label={label}
          isSelected={isCountrySelected(id)}
          onChange={handleToggleCountry(country)}
        />
      }
    />
  );
}
